export default __webpack_public_path__ + "static/media/Sandy_Bus-01_Single-10.2a18c234.jpg";